
document.addEventListener('DOMContentLoaded', function () {
  function translateCartDateLabels() {
   
    const nodes = document.querySelectorAll('.cart-drawer, .cart__items, .cart-items');
    
    nodes.forEach(node => {
      
      node.querySelectorAll('*').forEach(el => {
        if (el.childNodes.length) {
          el.childNodes.forEach(child => {
            if (child.nodeType === 3 && child.textContent.includes('Date')) {
              child.textContent = child.textContent.replace(/Date\s*:/i, 'Dato:');
            }
          });
        }
      });
    });
  }

  
  translateCartDateLabels();

  
  const observer = new MutationObserver(() => {
    translateCartDateLabels();
  });
  observer.observe(document.body, { childList: true, subtree: true });
});
